import { createSlice } from '@reduxjs/toolkit';

/**
 * @todo Удалить после завершения эксперимента
 * @description Данный функционал появился в задаче CD-253014, будет удалён в задаче 	CD-253668
 */
const initialState = false;

const showFullListSliceSlice = createSlice({
  name: 'showFullList',
  reducers: {},
  initialState,
});

export const showFullListReducer = showFullListSliceSlice.reducer;
